// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import type {ProfileFrameCatalogResponse} from '@fluxer/schema/src/domains/user/ProfileFrameSchemas';

export async function fetchProfileFrameCatalog(): Promise<ProfileFrameCatalogResponse> {
	const response = await http.get<ProfileFrameCatalogResponse>(Endpoints.PROFILE_FRAMES);
	return response.body;
}
